import React, { Fragment, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setEnableMobileMenu } from "../../../reducers/ThemeOptions";
import { MainNav, ClinicNav, DoctorNav, ScheduleNav } from "./NavItems";
import { canAny, hasAnyRole } from "../../../auth/permissions";

type Props = {
  item: any;
  toggleMobileSidebar: any;
};

const SubMenu = ({ item, toggleMobileSidebar }: Props) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const location = useLocation();

  const toggleSubMenu = (e: any) => {
    if (!item.to || item.content) {
      e.preventDefault();
      e.stopPropagation();
      setIsSubMenuOpen(!isSubMenuOpen);
    } else if (item.to && !item.external) {
      toggleMobileSidebar();
    }
  };

  const hasSubmenu = item.content && item.content.length > 0;

  const isActive =
    location.pathname === item.to ||
    (hasSubmenu &&
      item.content.some((child: any) => child.to === location.pathname));

  const LinkComponent = item.external ? "a" : Link;
  const linkProps = item.external
    ? { href: item.to, target: "_blank", rel: "noopener noreferrer" }
    : { to: item.to || "#" };

  return (
    <li className={`metismenu-item ${isActive ? "active" : ""}`}>
      <LinkComponent
        {...linkProps}
        className={`metismenu-link text-sm font-medium ${
          isActive ? "active" : ""
        }`}
        onClick={toggleSubMenu}
      >
        <i className={`metismenu-icon ${item.icon}`} />
        {item.label}
        {hasSubmenu && (
          <i
            className={`metismenu-state-icon pe-7s-angle-${
              isSubMenuOpen ? "up" : "down"
            }`}
          />
        )}
      </LinkComponent>
      {hasSubmenu && (
        <ul className={`metismenu-container ${isSubMenuOpen ? "visible" : ""}`}>
          {item.content.map((child: any, i: any) => (
            <li key={i} className="metismenu-item">
              <Link
                to={child.to}
                className={`metismenu-link ${
                  location.pathname === child.to ? "active" : ""
                }`}
                onClick={toggleMobileSidebar}
              >
                {child.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

type NavProps = {
  enableMobileMenu: any;
  setEnableMobileMenu: any;
};

const Nav = ({ enableMobileMenu, setEnableMobileMenu }: NavProps) => {
  const toggleMobileSidebar = () => {
    if (enableMobileMenu) {
      setEnableMobileMenu(false);
    }
  };

  const filterItems = (items: any[]) =>
    items
      .map((item): any => {
        const content = item.content ? filterItems(item.content) : item.content;

        const allowedByPerms = canAny(item.requiredPerms ?? []);
        const allowedByRoles = hasAnyRole(item.requiredRoles ?? []);

        const allowed =
          (allowedByPerms && allowedByRoles) ||
          (Array.isArray(content) && content.length > 0);

        if (!allowed) return null;
        return { ...item, content };
      })
      .filter(Boolean);

  const renderMenu = (items: any) =>
    filterItems(items).map((item: any, i: any) => (
      <SubMenu key={i} item={item} toggleMobileSidebar={toggleMobileSidebar} />
    ));

  return (
    <Fragment>
      <div className="vertical-nav-menu">
        <h5 className="app-sidebar__heading">Tổng quan</h5>
        <ul className="metismenu-container">{renderMenu(MainNav)}</ul>

        <h5 className="app-sidebar__heading">Lịch khám</h5>
        <ul className="metismenu-container">{renderMenu(ScheduleNav)}</ul>

        <h5 className="app-sidebar__heading">Phòng khám</h5>
        <ul className="metismenu-container">{renderMenu(ClinicNav)}</ul>

        <h5 className="app-sidebar__heading">Chuyên gia</h5>
        <ul className="metismenu-container">{renderMenu(DoctorNav)}</ul>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch: any) => ({
  setEnableMobileMenu: (enable: any) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);
